<template>
    <div>
        <resource-form
                :endpoint="endpoint"
                :method="method"
                :rules="rules"
                :schema="schema"
                :model="tagModel"
                permission="tag_create"
                @closed="handleCloseModal"
                :button_style="{'margin-left': '0 !important'}"
        >
            <template #title>{{ modalTitle }}</template>
            <template #button>{{'app.add_tag' | trans}}</template>
            <template #form="{ resource }">
                <v-flex xs12>
                    <v-text-field v-model="resource.name"
                                  :rules="rules.name"
                                  required
                                  :label="'app.name' | trans"
                                  :error-messages="nameError"
                                  @input="debounceValidateName(resource.name, resource.type)"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-select v-model="resource.type"
                              :rules="rules.type"
                              item-text="label"
                              item-value="value"
                              required
                              :items="typeOptions"
                              :label="`app.type` | trans"
                              @input="debounceValidateName(resource.name, resource.type)"
                    ></v-select>
                </v-flex>
                <v-flex xs12  v-if="hasPermission('tag_system_create')">
                  <v-checkbox color="primary" v-model="resource.system" :label="'app.tags.system_tag' | trans"></v-checkbox>
                </v-flex>
            </template>
        </resource-form>
    </div>
</template>

<script>
  import { trans } from '../app';
  import has from 'lodash/has';
  import debounce from 'lodash/debounce';
  import { stringify } from 'qs';
  import {mapGetters} from "vuex";

  export default {
    props: {
      model: Object,
    },
    data: () => ({
      tagModel: null,
      schema: {
        name: null,
        type: null,
      },
      nameError: [],
      rules: {
        name: [
          v => !!v || trans('validation.required', { 'attribute': trans('app.name') }),
          v => v && v.length <= 255 || trans('validation.max.string', {
            attribute: trans('app.name'),
            max: 255,
          }),
          v => v && v.length >= 3 || trans('validation.min.string', {
            attribute: trans('app.name'),
            min: 3,
          }),
        ],
        type: [
          v => !!v || trans('validation.required', { 'attribute': trans('app.type') }),
        ],
      },
      typeOptions: [
        { label: trans('page.tags.diet'), value: 'diet' },
        { label: trans('page.tags.schema'), value: 'schema' },
        { label: trans('page.tags.product'), value: 'product' },
      ],
    }),
    created() {
      this.debounceValidateName = debounce(this.validateName, 200);
    },
    watch: {
      model(val) {
        this.tagModel = val;
      },
    },
    methods: {
      handleCloseModal() {
        this.tagModel = null;
        this.$emit('modal_closed');
      },
      async validateName(name, type) {
        if (!name || name.length < 4 || !type) {
          this.nameError = [];
          return true;
        }

        const { data } = await axios.get('/v2/tags?' + stringify({
          perPage: 1,
          name,
          type,
        }));

        if (data.meta.total === 0 || has(this.model, 'id') && data.data[0].id === this.model.id) {
          this.nameError = [];
          return;
        }

        this.nameError.push(trans('validation.unique_tag_name', { 'attribute': name }));
      },
    },
    computed: {
      ...mapGetters(['hasPermission']),
      method() {
        return has(this.model, 'id') ? 'PATCH' : 'POST';
      },
      endpoint() {
        if (has(this.model, 'id')) {
          return `/v2/tags/${this.model.id}`;
        }

        return '/v2/tags';
      },
      modalTitle() {
        return has(this.model, 'id') ? trans('app.edit_tag') : trans('app.add_tag');
      },
    },
  }
  ;
</script>
